
import { PasswordResetNotification } from "./PasswordResetNotification";
import { CustomLoginForm } from "./CustomLoginForm";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

interface LoginFormProps {
  redirectUrl: string;
  onToggleForm: () => void;
  showPasswordResetNotification?: boolean;
}

export const LoginForm = ({
  redirectUrl,
  onToggleForm,
  showPasswordResetNotification = false
}: LoginFormProps) => {
  const [isInitializing, setIsInitializing] = useState(true);
  
  // Add a short initialization delay to ensure auth state is fully loaded
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitializing(false);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (isInitializing) {
    return (
      <div className="flex flex-col items-center justify-center p-2 space-y-1">
        <Loader2 className="h-5 w-5 animate-spin text-green-400" />
        <p className="text-xs text-zinc-400">Loading sign in form...</p>
      </div>
    );
  }
  
  return (
    <div className="w-full">
      {/* Single "Sign in" text */}
      {showPasswordResetNotification && <PasswordResetNotification />}
      
      <CustomLoginForm 
        redirectUrl={redirectUrl}
        onToggleForm={onToggleForm}
        showPasswordResetNotification={showPasswordResetNotification}
      />
    </div>
  );
};
